import { Module } from 'vuex'

interface HistoryPageState {
  pageIndex: number
  isFirstOpendPage: boolean
  isNotMoreHistoryList: boolean
  historyExpandedList: { [judgeId: number]: boolean }
  historyLoadingList: { [judgeId: number]: boolean }
}

export const historyPageStateModule = (): Module<HistoryPageState, any> => {
  return {
    namespaced: true,
    state: {
      pageIndex: 0,
      isFirstOpendPage: true,
      isNotMoreHistoryList: false,
      historyExpandedList: {},
      historyLoadingList: {}
    },
    mutations: {
      setPageIndex(state, { pageIndex }: { pageIndex: number }) {
        state.pageIndex = pageIndex
      },
      setIsFirstOpendPage(state, { flag }: { flag: boolean }) {
        state.isFirstOpendPage = flag
      },
      setIsNotMoreHistoryList(state, { flag }: { flag: boolean }) {
        state.isNotMoreHistoryList = flag
      },
      setHistoryExpandedList(state, { list }: { list: { [judgeId: number]: boolean } }) {
        state.historyExpandedList = list
      },
      setHistoryExpandedFlag(state, { judgeId, flag }: { judgeId: number; flag: boolean }) {
        state.historyExpandedList[judgeId] = flag
      },
      setHistoryLoadingList(state, { list }: { list: { [judgeId: number]: boolean } }) {
        state.historyLoadingList = list
      },
      setHistoryLoadingFlag(state, { judgeId, flag }: { judgeId: number; flag: boolean }) {
        state.historyLoadingList[judgeId] = flag
      }
    },
    actions: {},
    getters: {
      pageIndex: state => state.pageIndex,
      isFirstOpendPage: state => state.isFirstOpendPage,
      isNotMoreHistoryList: state => state.isNotMoreHistoryList,
      historyExpandedList: state => state.historyExpandedList,
      historyLoadingList: state => state.historyLoadingList
    }
  }
}
